import { ActionReducer, createFeatureSelector, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import * as AppActions from '../actions/app.actions';
import { IIndexedNotification } from '../models/cpq.models';
import { Alert } from '../models/alert.models';

export interface AppState {
  alert: Alert | null;
  notifications: IIndexedNotification[];
  fullPageLoaderList: Array<string>;
}

// Initialize State start
export const initialState: AppState = {
  alert: null,
  notifications: [],
  fullPageLoaderList: [],
};
// Initialize State end

// Selectors start
const getAppFeatureState: MemoizedSelector<object, AppState> = createFeatureSelector<AppState>('app');

export const getAlert: MemoizedSelector<object, Alert | null> = createSelector(
  getAppFeatureState,
  state => state.alert,
);

export const getNotification: MemoizedSelector<object, IIndexedNotification[]> = createSelector(
  getAppFeatureState,
  state => state.notifications,
);

export const selectFullPageLoaderList: MemoizedSelector<object, Array<string>> = createSelector(
  getAppFeatureState,
  state => state.fullPageLoaderList,
);
// Selectors end

// Reducer start
export const AppReducer: ActionReducer<AppState> = createReducer(
  initialState,
  on(AppActions.setAlert, (state, {alert}) => {
    return {
      ...state,
      alert,
    };
  }),
  on(AppActions.clearAlert, (state) => {
    return {
      ...state,
      alert: null,
    };
  }),
  on(AppActions.appendNotification, (state, {notification}) => {
    const notifications: IIndexedNotification[] = state.notifications;
    const nextNotificationId: number = notifications.length === 0 ? 1 : Math.max(...notifications.map(n => n.id)) + 1;
    return {
      ...state,
      notifications: [
        ...state.notifications,
        {...notification, id: nextNotificationId},
      ],
    };
  }),
  on(AppActions.closeNotification, (state, {notificationId}) => {
    const notifications: IIndexedNotification[] = [...state.notifications];
    const notificationIdx: number = notifications.findIndex(notification => notification.id === notificationId);
    if (notificationIdx !== -1) {
      notifications.splice(notificationIdx, 1);
    }

    return {
      ...state,
      notifications,
    };
  }),
  on(AppActions.clearNotifications, (state) => {
    return {
      ...state,
      notifications: [],
    };
  }),
  on(
    AppActions.navBarLoaded,
    AppActions.homePageBannerLoaded,
    (state, {name}) => {
      if (state.fullPageLoaderList.includes(name)) {
        return state;
      } else {
        return {
          ...state,
          fullPageLoaderList: [...state.fullPageLoaderList, name],
        };
      }
    }),
);
// Reducer end
